<div class="flex flex-column justify-content-evenly">
    <div *ngIf="person">
        <div class="w-10 m-auto">
            <h3 class="text-center">Añadir imágenes</h3>
            <p class="text-center">Debes tener entre 3 y 20 imágenes</p>
        </div>
        <div class="flex justify-content-evenly my-3">
            <div class="w-11 md:w-6">
                <p-fileUpload name="uploadedFile[]" url="{{ uploadUrl }}" (onUpload)="onUpload($event)" [multiple]="true" [auto]="true"
                    chooseIcon="pi pi-upload" styleClass="w-full" (onBeforeUpload)="onBeforeUpload()" [disabled]="fileLimit < 1"
                    chooseLabel="Buscar imágenes" uploadLabel="Cargar" cancelLabel="Cancelar" [maxFileSize]="200000000" accept="image/jpg,image/png,image/jpeg,video/mp4" [fileLimit]="fileLimit"
                    invalidFileTypeMessageDetail="" invalidFileTypeMessageSummary="El archivo {0} no es una imagen."
                    invalidFileSizeMessageSummary="El archivo {0} es demasiado grande" invalidFileSizeMessageDetail="El tamaño máximo es 190 MB"
                    invalidFileLimitMessageSummary="" invalidFileLimitMessageDetail="Seleccione máximo {0} archivos.">
                </p-fileUpload>
            </div>
        </div>
        <p-galleria [value]="person.mediaContent" [showThumbnails]="false"
            [circular]="true" [fullScreen]="true" [(visible)]="showGallery" [(activeIndex)]="activeIndex" 
            [showItemNavigators]="true" [showThumbnailNavigators]="false" [showIndicators]="true" 
            [containerStyle]="{'text-align':'center'}">
            <ng-template pTemplate="item" let-media>
                <p-image *ngIf="media.type !== '.mp4'" src="{{ uploadLocation + media.fileName }}" imageClass="full-screen-image"></p-image>
                <video *ngIf="media.type === '.mp4'" width="70%" controls controlsList="nodownload" src="{{ uploadLocation + media.fileName }}">
                </video>
            </ng-template>
        </p-galleria>
        <div class="w-10 m-auto">
            <h3 class="text-center">Imágenes cargadas</h3>
            <p class="text-center text-sm"><i class="pi pi-exclamation-circle text-sm"></i> La imagen principal es la que se muestra en los listados de busqueda</p>
        </div>
        <div *ngIf="person.mediaContent" class="flex flex-row flex-wrap w-10 md:w-7 m-auto my-4 gap-4">
            <p-confirmDialog></p-confirmDialog>
            <div *ngFor="let image of person.mediaContent; let index = index" key="index" class="flex flex-column w-5 lg:w-2 gap-1">
                <img *ngIf="image.type !== '.mp4'" [src]="thumbnailLocation + image.fileName" class="w-full cursor-pointer" (click)="imageClick(index)" />
                <video *ngIf="image.type === '.mp4'" width="135" height="180" (click)="imageClick(index)">
                    <source src="{{ uploadLocation + image.fileName }}#t=1">
                </video>
                <p-button *ngIf="image.type !== '.mp4'" label="{{image.isProfile === 1 ? 'Imagen principal' : 'Establecer principal'}}" 
                    icon="{{image.isProfile === 1 ? 'pi pi-check' : ''}}" styleClass="w-full" [disabled]="image.isProfile === 1"
                    (click)="setAsProfile(image.fileName)"></p-button>
                <div *ngIf="image.type === '.mp4'" style="background-color: #4e4c4c;">
                    <p class="px-3 text-white font-bold"><i class="pi pi-video"></i> Video</p>
                </div>
                <p-button label="Eliminar" icon="pi pi-times" styleClass="w-full" (onClick)="confirm(image.fileName)" 
                    [disabled]="image.isProfile === 1 || person.mediaContent.length <= 3"></p-button>
            </div>
        </div>
    </div>
    <p-dialog header="Cargando imágenes" [modal]="true" [(visible)]="loading" [closeOnEscape]="false" [resizable]="false" [closable]="false" [blockScroll]="true">
        <div style="height: 105px;" class="flex justify-content-center">
            <p-progressSpinner strokeWidth="5"></p-progressSpinner>
        </div>
    </p-dialog>
</div>